import { computeNipRows } from "@/lib/nutrition";

/**
 * On-screen FSANZ Nutrition Information Panel — a compliant two-column
 * (per serving / per 100g) table matching the printed sticker. Pass either
 * `rows` (precomputed) or a `nutrition` object.
 */
export function NutritionPanel({ rows, nutrition, className = "" }) {
  const data = rows || computeNipRows(nutrition || {});
  const nut = nutrition || {};
  return (
    <div data-testid="nutrition-panel" className={`mt-1 border border-black text-[9px] leading-tight font-mono bg-white text-black ${className}`}>
      <div className="font-bold text-center border-b border-black px-1 py-0.5">NUTRITION INFORMATION</div>
      {(nut.servings_per_pack || nut.serving_size) && (
        <div className="px-1 py-0.5 border-b border-black">
          {nut.servings_per_pack ? <div>Servings per package: {nut.servings_per_pack}</div> : null}
          {nut.serving_size ? <div>Serving size: {nut.serving_size}</div> : null}
        </div>
      )}
      <table className="w-full border-collapse">
        <thead>
          <tr className="border-b border-black">
            <th className="text-left px-1 py-0.5 font-normal"> </th>
            <th className="text-right px-1 py-0.5 font-semibold">Per serve</th>
            <th className="text-right px-1 py-0.5 font-semibold">Per 100g</th>
          </tr>
        </thead>
        <tbody>
          {data.map((r) => (
            <tr key={r.key} className="border-b border-black/40 last:border-0">
              <td className={`px-1 py-0.5 ${r.indent ? "pl-3" : ""}`}>{r.label}</td>
              <td className="text-right px-1 py-0.5 tabular-nums">{r.perServe}</td>
              <td className="text-right px-1 py-0.5 tabular-nums">{r.per100g}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
